(function () {
  'use strict';

  /* SHARED PRODUCT JSON CACHE (Sept 3 2026).

     setPreferredDefault() below and loadVariants() in snippets/tl-pdp-enhancements.liquid
     were each doing their own fetch('/products/<handle>.js') on every product page - two
     requests for identical bytes, two JSON parses. (Three before the default-variant
     redirect was removed from snippets/tl-preorder-fix.liquid, which fetched it as well.)

     Defined identically and idempotently in both files because load order is not
     guaranteed: this file is deferred from variant-picker.liquid, the other runs inline at
     the end of <body>. Whichever executes first defines it, the other reuses it. The
     PROMISE is cached rather than the result, so two callers racing before the response
     lands still share a single request. */
  window.tlFetchProduct = window.tlFetchProduct || function (handle) {
    window.__tlProductJson = window.__tlProductJson || {};
    if (!window.__tlProductJson[handle]) {
      window.__tlProductJson[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); });
    }
    return window.__tlProductJson[handle];
  };

  // 1. Strip WAIR injected border-bottom + font overrides inline via JS
  // Their .wair-css x3 specificity beats CSS !important; inline !important wins
  function stripWairStyles(el) {
    el.querySelectorAll('[class*="wr-border-b"]').forEach(function (span) {
      span.style.setProperty('border-bottom', 'none', 'important');
      span.style.setProperty('border-bottom-width', '0', 'important');
      span.style.setProperty('font-size', 'inherit', 'important');
      span.style.setProperty('font-weight', 'inherit', 'important');
      span.style.setProperty('letter-spacing', 'inherit', 'important');
    });
  }
  document.querySelectorAll('.predict-placement').forEach(function (el) {
    new MutationObserver(function () { stripWairStyles(el); })
      .observe(el, { childList: true, subtree: true });
  });

  // 2. Hide WAIR logo when widget modal opens
  new MutationObserver(function () {
    document.querySelectorAll('[class*="predict-"]:not(.predict-placement) img, [id*="predict-"] img').forEach(function (img) {
      img.style.setProperty('display', 'none', 'important');
    });
  }).observe(document.body, { childList: true, subtree: true });

  // 3. Preferred default variant on first load of a PRODUCT PAGE.
  //
  //    SEPT 3 2026 - THIS IS NOW THE ONLY THING DOING IT, AND IT ACTUALLY RUNS.
  //    snippets/tl-preorder-fix.liquid used to fetch the product JSON and then call
  //    window.location.replace() to land on Classic/L, which meant every product page
  //    arrived at without ?variant= loaded itself twice - the whole document, its CSS and
  //    its JS, thrown away and fetched again. That redirect is gone.
  //
  //    Its side effect was that this function never ran on a PDP: the redirect always put
  //    ?variant= in the URL, so the guard below returned immediately every time. With the
  //    redirect removed, a bare PDP URL now reaches this code - which is strictly better
  //    coverage, because the old redirect matched on v.title.split(' / ') containing the
  //    literal 'Classic' and so silently did nothing on products with no Fit option
  //    (French Terry Tee, Long Sleeve Tee). pickChoice() handles fitIdx === -1 properly,
  //    so those products default to Large too now.
  //
  //
  //    WHAT IT DOES NOW. Still prefers Classic / L, because L is the best seller -
  //    but only when Classic/L is ACTUALLY SELLABLE. If it is not, it walks
  //    SIZE_PREF (L, M, XL, S, 2XL, 3XL) inside the shopper's current colour and
  //    fit; if nothing in that fit is sellable it tries the other fit; if nothing
  //    in the colour is sellable it leaves the picker exactly as the theme
  //    rendered it. It never changes the COLOUR - colour is the shopper's (or the
  //    grid link's) choice, size is the only thing we are guessing at.
  //
  //    THE BUG THIS REPLACES (found Aug 9 2026). The old version tested
  //    `if (inp && !inp.disabled)`. Prestige does not disable the radio for a
  //    sold-out option - it renders the LABEL as
  //    `<label class="block-swatch is-disabled">` and leaves the input enabled -
  //    so that test was always true and the picker cheerfully landed on a dead
  //    size. On /products/french-terry-tee, L is sold out in all three colours,
  //    so every visitor to an $84 product saw "Join the Waitlist" even though six
  //    variants were in stock. Availability is now read from
  //    /products/<handle>.js - the same source the cross-availability strikes in
  //    snippets/tl-pdp-enhancements.liquid already use - instead of being inferred
  //    from a DOM property that never meant what it looked like it meant.
  //    DO NOT go back to inp.disabled. If you want a synchronous signal, the
  //    honest one is the label's `is-disabled` class, which IS server-rendered.
  //
  //    THIS FUNCTION ONCE BROKE THE CROSS-SELL QUICK-BUY MODAL (fixed Aug 6 2026).
  //    The <script src> that loads this file is emitted by
  //    snippets/variant-picker.liquid, so it travelled inside every copy of the
  //    picker - including the one Prestige clones into <quick-buy-modal>. Script
  //    elements produced by DOMParser are NOT flagged "already started", so each
  //    time <product-rerender> swapped fresh markup into the modal the tag was
  //    re-inserted into the live document and re-executed. The defaulting logic
  //    then clicked size L straight back on, ~200ms after the shopper picked
  //    anything else. The size picker looked completely dead and the CTA stayed on
  //    the sold-out default, so the cart cross-sell could not be bought from.
  //
  //    FOUR THINGS KEEP IT CONTAINED NOW:
  //      a) variant-picker.liquid only emits the tag when context == 'main_product'
  //      b) the query below is scoped to variant-picker[context="main_product"],
  //         so even if the file is loaded elsewhere it cannot touch a quick-buy
  //         or featured-product picker
  //      c) a window-level once-flag, so a re-execution can never re-drive the
  //         selection after the shopper has interacted
  //      d) userTouched - if the shopper changes any option while the availability
  //         fetch is still in flight, we stand down entirely
  //    Do not remove (b), (c) or (d) if (a) is ever relaxed.

  // Best seller first, then the sizes nearest it. Change the order here, nowhere else.
  var SIZE_PREF = ['L', 'M', 'XL', 'S', '2XL', 'XXL', '3XL', 'XXXL', 'XS', '4XL'];
  // Preferred fit, tried before whatever the theme happened to select.
  var FIT_PREF = ['Classic'];

  var userTouched = false;
  var applying = false;

  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim(); }

  function mainPicker() {
    return document.querySelector('variant-picker[context="main_product"]');
  }

  // Read the picker into [{ name, selected, values:[{value, input}] }], in DOM order,
  // which is also Shopify option order (option1, option2, option3).
  function readGroups(picker) {
    var groups = [];
    picker.querySelectorAll('.variant-picker__option').forEach(function (fs) {
      var legend = fs.querySelector('legend');
      var name = legend ? norm(legend.textContent).replace(/:$/, '') : '';
      var values = [];
      var selected = null;
      fs.querySelectorAll('input[type="radio"]').forEach(function (inp) {
        var lbl = inp.id ? fs.querySelector('label[for="' + inp.id + '"]') : null;
        if (!lbl) lbl = inp.nextElementSibling;
        var val = norm((lbl && (lbl.getAttribute('data-option-value') || lbl.textContent)) || inp.value);
        if (!val) return;
        values.push({ value: val, input: inp });
        if (inp.checked) selected = val;
      });
      if (values.length) groups.push({ name: name, selected: selected, values: values });
    });
    return groups;
  }

  function indexOfGroup(groups, re) {
    for (var i = 0; i < groups.length; i++) { if (re.test(groups[i].name)) return i; }
    return -1;
  }

  function orderedValues(group, pref) {
    var all = group.values.map(function (v) { return v.value; });
    var out = [];
    function push(v) {
      if (!v) return;
      for (var i = 0; i < all.length; i++) {
        if (all[i].toUpperCase() === v.toUpperCase() && out.indexOf(all[i]) === -1) out.push(all[i]);
      }
    }
    pref.forEach(push);
    push(group.selected);
    all.forEach(function (v) { if (out.indexOf(v) === -1) out.push(v); });
    return out;
  }

  // wanted is indexed by option position - 1; null means "anything".
  function isSellable(data, wanted) {
    for (var i = 0; i < data.variants.length; i++) {
      var v = data.variants[i];
      if (!v.available) continue;
      var ok = true;
      for (var j = 0; j < wanted.length; j++) {
        if (wanted[j] == null) continue;
        if (norm(v.options[j]).toUpperCase() !== norm(wanted[j]).toUpperCase()) { ok = false; break; }
      }
      if (ok) return true;
    }
    return false;
  }

  function pickChoice(groups, data) {
    var sizeIdx = indexOfGroup(groups, /^size$/i);
    if (sizeIdx === -1) return null;
    var fitIdx = indexOfGroup(groups, /^fit$/i);

    // Anything that is not Fit or Size (i.e. Colour) is pinned to what is selected.
    var base = groups.map(function (g, i) {
      return (i === sizeIdx || i === fitIdx) ? null : g.selected;
    });

    var fits = fitIdx === -1 ? [null] : orderedValues(groups[fitIdx], FIT_PREF);
    var sizes = orderedValues(groups[sizeIdx], SIZE_PREF);

    for (var f = 0; f < fits.length; f++) {
      for (var s = 0; s < sizes.length; s++) {
        var wanted = base.slice();
        if (fitIdx !== -1) wanted[fitIdx] = fits[f];
        wanted[sizeIdx] = sizes[s];
        if (isSellable(data, wanted)) {
          return { fitIdx: fitIdx, fit: fits[f], sizeIdx: sizeIdx, size: sizes[s] };
        }
      }
    }
    return null;
  }

  // Re-read the picker every time: <product-rerender> replaces the markup after each
  // click, so any node reference taken before a click is stale.
  function entryFor(optionIndex, value) {
    var picker = mainPicker();
    if (!picker || !value) return null;
    var groups = readGroups(picker);
    var g = groups[optionIndex];
    if (!g) return null;
    for (var i = 0; i < g.values.length; i++) {
      if (g.values[i].value.toUpperCase() === value.toUpperCase()) return g.values[i];
    }
    return null;
  }

  function clickSize(choice) {
    var entry = entryFor(choice.sizeIdx, choice.size);
    if (entry && !entry.input.checked) entry.input.click();
  }

  function applyChoice(choice) {
    if (choice.fitIdx !== -1 && choice.fit) {
      var fitEntry = entryFor(choice.fitIdx, choice.fit);
      if (fitEntry && !fitEntry.input.checked) {
        fitEntry.input.click();
        // Fit changed, so the size chips are about to be re-rendered. Set the size
        // once the new markup has landed, and once more as a cheap retry.
        setTimeout(function () { clickSize(choice); }, 450);
        setTimeout(function () { clickSize(choice); }, 1200);
        return;
      }
    }
    clickSize(choice);
  }

  function setPreferredDefault() {
    try {
      if (window.__tlDefaultLargeRan || window.__tlDefaultLargeFetching) return;
      if (new URLSearchParams(window.location.search).has('variant')) return;
      var picker = mainPicker();
      if (!picker) return;
      var handle = picker.getAttribute('handle');
      if (!handle) return;
      window.__tlDefaultLargeFetching = true;
      window.tlFetchProduct(handle)
        .then(function (data) {
          window.__tlDefaultLargeFetching = false;
          if (window.__tlDefaultLargeRan || userTouched) return;
          if (!data || !data.variants || !data.variants.length) return;
          var p = mainPicker();
          if (!p) return;
          var choice = pickChoice(readGroups(p), data);
          // Nothing sellable in this colour - leave the theme's own default alone.
          if (!choice) return;
          window.__tlDefaultLargeRan = true;
          applying = true;
          applyChoice(choice);
          setTimeout(function () { applying = false; }, 2000);
        })
        .catch(function () { window.__tlDefaultLargeFetching = false; });
    } catch (e) { /* never break the PDP over a default */ }
  }

  // If the shopper picks something themselves while the fetch is in flight, stand down.
  document.addEventListener('change', function (e) {
    if (applying) return;
    if (e.target && e.target.matches && e.target.matches('variant-picker input[type="radio"]')) {
      userTouched = true;
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setPreferredDefault);
  } else {
    setPreferredDefault();
  }
})();
